export default {
  "fr": {
    "window": {
      "app": "App",
      "customersDashboard": "Accueil",
      "customersDecisionDocuments": "Décision",
      "customersDecisionProposals": "Propositions",
      "customersDecisionTickets": "Décision",
      "customersDecisionTicketsShow": "Décision",
      "customersDecisions": "Décisions",
      "customersDocuments": "Documents",
      "customersDocumentsAll": "Aperçu des documents",
      "customersDocumentsFolder": "Catégorie de documents",
      "customersDocumentsFolders": "Catégories de documents",
      "customersInspirationLists": "Inspirations",
      "customersInspirationListsShow": "Inspirations",
      "customersInstallmentTerms": "Paiements partiels",
      "customersIssues": "Aftercare",
      "customersProjectInformation": "Information Projet",
      "customersQuestionLists": "FAQs",
      "customersQuestionListsShow": "FAQs",
      "customersRoot": "Accueil",
      "customersRootSettingsProfile": "Profil",
      "customersSettingsProfile": "Profil",
      "customersTickets": "Conversations",
      "customersTicketsNew": "Nouvelle Conversation",
      "customersTicketsShow": "Conversation",
      "employeesClientContacts": "Contacts",
      "employeesClientContactsNewCustomer": "Nouveau Client",
      "employeesClientContactsNewEmployee": "Nouveau Collègue",
      "employeesClientContactsNewPartner": "Nouveau Partenaire",
      "employeesClientContactsType": "Contacts",
      "employeesClientDashboard": "Accueil",
      "employeesClientProjects": "Projets",
      "employeesClientProjectsNew": "Nouveay projet",
      "employeesClientTickets": "Conversations",
      "employeesClientTicketsNew": "Nouvelle Conversation",
      "employeesClientTicketsShow": "Conversation",
      "employeesMarketplace": "Marketplace",
      "employeesProjectActivity": "Activités",
      "employeesProjectAnnouncements": "Actualités",
      "employeesProjectDecisionActivity": "Activity",
      "employeesProjectDecisionDocuments": "Décision",
      "employeesProjectDecisionProposalTemplate": "Modèles de proposition",
      "employeesProjectDecisionProposals": "Proposals",
      "employeesProjectDecisionReminders": "Rappels",
      "employeesProjectDecisionTickets": "Conversations",
      "employeesProjectDecisionTicketsShow": "Conversation",
      "employeesProjectDecisionTypeNew": "Nouvelle Décision",
      "employeesProjectDecisionTypes": "Décisions",
      "employeesProjectDecisions": "Décisions",
      "employeesProjectDecisionsEdit": "Décisions",
      "employeesProjectDecisionsNew": "Nouvelle Décision",
      "employeesProjectDocuments": "Documents",
      "employeesProjectInformationPageActivity": "Activité",
      "employeesProjectInformationPageDecisions": "Décisions",
      "employeesProjectInformationPageDocuments": "Documents",
      "employeesProjectInformationPageInformation": "Information",
      "employeesProjectInformationPageInstallments": "Paiements partiels",
      "employeesProjectInformationPageLevels": "Information",
      "employeesProjectInformationPageMilestones": "Jalons",
      "employeesProjectInformationPageSpaces": "Espaces",
      "employeesProjectInformationPageSurveys": "Enquêtes",
      "employeesProjectInformationPageTasks": "Tasks",
      "employeesProjectInstallmentGroup": "Finances",
      "employeesProjectInstallmentGroupNew": "Nouvelle période de Versement",
      "employeesProjectInstallmentGroupsMatrix": "Versements",
      "employeesProjectInstallmentNew": "Nouveau Versements",
      "employeesProjectIssueListTypeIssues": "Liste de points - Tous les points",
      "employeesProjectIssueListTypeNew": "Nouveau liste de points",
      "employeesProjectIssueListTypeUnits": "Liste de points - Présentation de l'unité",
      "employeesProjectIssueListTypes": "Listes de points",
      "employeesProjectIssueListUnitDocuments": "Points d'unité - Documents",
      "employeesProjectIssueListUnitIssues": "Points d'unité",
      "employeesProjectIssueListUnitTickets": "Points d'unité - Conversations",
      "employeesProjectIssueListsNew": "Nouveaux points",
      "employeesProjectQuestionLists": "FAQs",
      "employeesProjectQuestionListsShow": "FAQ",
      "employeesProjectSalesUnits": "Ventes",
      "employeesProjectSurveyNew": "Nouveau Enquête",
      "employeesProjectSurveyTypeNew": "Nouveau Enquête",
      "employeesProjectSurveyTypes": "Enquêtes",
      "employeesProjectSurveys": "Enquête",
      "employeesProjectTickets": "Conversations",
      "employeesProjectTicketsNew": "Nouvelle Conversation",
      "employeesProjectTicketsShow": "Conversations",
      "employeesProjectTodoLists": "Tâches",
      "employeesSettingsClientAftercare": "Suivi",
      "employeesSettingsClientInformation": "Admin",
      "employeesSettingsClientIntegrations": "Intégrations",
      "employeesSettingsProfile": "Profil",
      "level": "Niveau",
      "mployeesProjectInstallmentGroups": "Finances",
      "partnersClientProjects": "Projets",
      "partnersProjectDecisionDocuments": "Documents",
      "partnersProjectDecisionProposals": "Propositions",
      "partnersProjectDecisionTickets": "Conversations",
      "partnersProjectDecisionTicketsShow": "Conversation",
      "partnersProjectDecisionTypesItems": "Décisions",
      "partnersProjectDecisions": "Décisions",
      "partnersProjectDocuments": "Documents",
      "partnersProjectDocumentsUnit": "Documents",
      "partnersProjectIssueListTypeIssues": "Liste de points - Tous les points",
      "partnersProjectIssueListTypeUnits": "Liste de points - Présentation de l'unité",
      "partnersProjectIssueListTypes": "Listes de points",
      "partnersProjectIssueListUnitDocuments": "Points d'unité - Documents",
      "partnersProjectIssueListUnitIssues": "Points d'unité",
      "partnersProjectIssueListUnitTickets": "Points d'unité - Conversations",
      "partnersSettingsProfile": "Profile",
      "root": "App"
    }
  }
}